<template>
  <div class="haidi-constructor">
    <bg-video filename="HSD" autoplay loop/>
    <!-- <div class="title pos-c">首次实现滴水不漏背后的科技创新</div> -->
    <img class="title pos-c" :src="require('./img/HSD-title.png')">
    <section class="btn-wrapper">
      <img class="btn-item icon-one" :src="require('./img/d01.png')" @click="getInfo('rubberWterstop')">
      <img class="btn-item icon-two" :src="require('./img/d02.png')" @click="getInfo('semirigidStructure')">
      <img class="btn-item icon-three" :src="require('./img/d03.png')" @click="getInfo('processManagement')">
      <img class="btn-item icon-four" :src="require('./img/d04.png')" @click="getInfo('compositeFoundation')">
      <img class="btn-item icon-five" :src="require('./img/d05.png')" @click="getInfo('bestProportionOfConcrete')">
      <!-- <img class="btn-item icon-six" :src="require('./img/d06.png')" @click="getInfo('bhajan')"> -->
      <!-- <img class="btn-item icon-seven" :src="require('./img/d07.png')" @click="getInfo('story')"> -->
      <MaxCard v-if="infoType" class="des-detail" @close="closeCard">
        <div class="title">
          <h3 v-if="typeof infoData.info === 'string'">{{ infoData.title }}</h3>
          <span class="detail">
            <p v-if="typeof infoData.info === 'string'">{{ infoData.info }}</p>
            <div v-if="typeof infoData.info === 'object'">
              <div v-for="(item,index) in infoData.info" :key="index">
                <h3>{{ item.title }}</h3>
                <div>{{ item.content }}</div>
              </div>
            </div>
          </span>
        </div>
      </MaxCard>
      <guide-button class="btn-lt" :style="{ zIndex: 10000 }" @click.native="$emit('close')">返回</guide-button>
    </section>
  </div>
</template>

<script>
import infoDataArr from '@/assets/data/7-3'
export default {
  name: 'HaidiConstructor',
  data () {
    return {
      from: {
        name: this.$route.meta.from || 'navigation',
        query: { loop: true },
      },
      infoType: '',
      infoDataArr,
      infoData: {},
    }
  },
  mounted () {
    this.$bgAudio.play()
  },
  beforeDestroy () {
    this.$bgAudio.pause()
  },
  methods: {
    getInfo (infoType) {
      infoDataArr.forEach(item => {
        if (item.name === infoType) {
          this.infoData = item
          this.infoType = infoType
        }
      })
    },
    closeCard () {
      this.infoType = false
    },
  },
}
</script>
<style lang="scss" scoped>
  .haidi-constructor {
    position: relative;
    z-index: 1001;
    height: 100%;
    & > .title {
      margin-top: 2.8rem;
      width: 7rem;
    }
    .btn-wrapper {
      background: url(./img/gradient.png);
      height: 100%;
      position: relative;
      .btn-item {
        cursor: pointer;
      }
      .icon-one {
        width: 2.5rem;
        position: absolute;
        top: 1.7rem;
        left: 3.1rem;
      }
      .icon-two {
        width: 2rem;
        position: absolute;
        top: 1.1rem;
        left: 7rem;
      }
      .icon-three {
        width: 2.6rem;
        position: absolute;
        top: 1.5rem;
        right: 2rem;
      }
      .icon-four {
        width: 2.5rem;
        position: absolute;
        top: 6.2rem;
        left: 4.5rem;
      }
      .icon-five {
        width: 3.3rem;
        position: absolute;
        top: 5.1rem;
        right: 0.8rem;
      }
      .icon-six{
        width: 3.3rem;
        position: absolute;
        top: 8.5rem;
        left: .5rem;
      }
      .icon-seven{
        width: 3.3rem;
        position: absolute;
        top: 9.5rem;
        left: .5rem;
      }
      .des-detail {
        .title {
          font-size: 0.4rem;
          text-align: left;
          margin-bottom: 0.2rem;
          &::-webkit-scrollbar {
          /*滚动条整体样式*/
            width: 12px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 12px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.2);
          }
          &::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
          }
        }
        .detail {
          font-size: .3rem;
          line-height: .01rem;
          font-size: .26rem;
          line-height: 0.44rem;
          text-align: left;
          height: 3rem;
          overflow-y: auto;

        }
      }
    }
  }
</style>
